import { Button } from 'components'
import { CSVLink } from 'react-csv'
import moment from 'moment'
import { useIntl } from 'react-intl'
import intl from 'localization/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons'
import { theme } from 'styles/root-theme'

interface UserData {
  name?: string
  email?: string
  created_at?: string | number | Date
}

interface UserWrapper {
  userData: UserData | null
  apiUserData?: unknown
}

interface CustomerData {
  name?: string
}

interface ExportUsersProps {
  customerData?: CustomerData
  usersData: UserWrapper[]
}

const ExportUsers = ({ customerData, usersData }: ExportUsersProps) => {
  const { formatMessage } = useIntl()

  return (
    <Button
      icon={
        <FontAwesomeIcon
          icon={faCloudDownloadAlt}
          style={{ marginRight: '8px', color: '#000000' }}
        />
      }
    >
      <CSVLink
        style={{
          textDecoration: 'none',
          color: '#000000',
        }}
        filename={`${customerData?.name} users.csv`}
        data={usersData
          ?.filter((u) => u.userData)
          .map((user) => ({
            name: user.userData?.name,
            email: user.userData?.email,
            created: moment(user.userData?.created_at).format(
              'DD.MM.YYYY, hh:mm',
            ),
          }))}
      >
        {formatMessage({
          id: intl.riskMonitoringNew('export-companies-button'),
        })}
      </CSVLink>
    </Button>
  )
}

export default ExportUsers
